import { BaseModel } from '../core/abstractions/base.model';
import { DashboardCardModel } from './dashboard-card.model';

export class DashboardConfigurationModel extends BaseModel {
    cards: DashboardCardModel[] = [];

    constructor(init?: DashboardConfigurationModel) {
        super();
        Object.assign(this, init);
    }
}
